import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
import { FullScreen } from 'foundations-components/transitional/components/FullScreen';
import { Lightbox } from 'foundations-components/transitional/components/Lightbox';
import { useTheme } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function Fullscreen({
  fullscreen,
  onClose,
  children
}) {
  const trellisTheme = useTheme();
  if (!fullscreen) return children;

  // if we're NOT in an iframe, we can use a lightbox
  if (window.self === window.top) return /*#__PURE__*/_jsx(Lightbox, {
    closeable: true,
    onClose: onClose,
    children: /*#__PURE__*/_jsx("div", {
      style: {
        height: '100vh',
        width: '100vw'
      },
      children: /*#__PURE__*/_jsx(Flex, {
        blockSize: "100%",
        alignItems: "center",
        children: /*#__PURE__*/_jsx(View, {
          flexGrow: 1,
          children: children
        })
      })
    })
  });

  // if we ARE in an iframe, the lightbox close transition looks bad,
  // so we use FullScreen instead
  return /*#__PURE__*/_jsx(FullScreen, {
    children: /*#__PURE__*/_jsx("div", {
      // focus ourselves, so pressing escape works
      // wait 60ms because of a race condition
      ref: el => {
        setTimeout(() => el === null || el === void 0 ? void 0 : el.focus(), 60);
      },
      style: {
        backgroundImage: `linear-gradient(${trellisTheme === null || trellisTheme === void 0 ? void 0 : trellisTheme.color['icon-core-default']}, ${trellisTheme === null || trellisTheme === void 0 ? void 0 : trellisTheme.color['fill-accent-neutral-default']})`,
        height: '100vh',
        position: 'relative'
      },
      onKeyDown: e => {
        if (e.key === 'Escape') onClose();
      },
      tabIndex: 0,
      children: /*#__PURE__*/_jsxs(Flex, {
        blockSize: "100%",
        alignItems: "center",
        paddingInline: "800",
        children: [/*#__PURE__*/_jsx(View, {
          position: "absolute",
          insetBlockStart: "24px",
          insetInlineEnd: "24px",
          children: /*#__PURE__*/_jsx(CloseButton, {
            color: "fill-tertiary-default",
            onClick: onClose
          })
        }), /*#__PURE__*/_jsx(View, {
          flexGrow: 1,
          children: children
        })]
      })
    })
  });
}